export default __webpack_public_path__ + "static/media/serbgo-screenshot-02.5aa7f632.png";